import React from "react";
import "../../../ReactKaamvalaWebsite/Pages/RefundPolicy/RefundPolicy.css";
const RefundPolicy = () => (
  <>
    <div className="refund_policy">
      <section className="refund_policy_section">
        <div className="container">
          <div className="col-md-12">
            <div className="refund_policy_title text-center py-4">
              <h1>Return and Refunds Policy</h1>
            </div>
            <p className="paragraph">
              At Kaamvala, we aim to deliver the best service possible. However,
              if you're dissatisfied with your purchase, you have the option to
              request a refund in line with our refund terms.
            </p>
          </div>
          <div className="container pb-3">
            <div className="row">
              <div className="col-md-12 col-lg-12">
                <div className="request_refund">
                  <h6>Steps to Request a Refund</h6>
                </div>
                <div className="refund_policy_points">
                  <ol className="refund_num">
                    <li>
                      <b>Raise a Ticket:</b>
                      Visit your account dashboard, click the “Help” section,
                      and submit your refund request by outlining the issue. We
                      will get back to you within 24 hours.
                    </li>
                    <li>
                      <b>Live chat Support:</b>
                      Use the live chat feature on our website (www.kaamvala.in)
                      or on the Kaamvala Recruiter App during business hours
                      (Monday to Friday, 10 AM to 7 PM).
                    </li>
                    <li>
                      <b>Email Us: </b>
                      Send an email explaining your concern to help@kaamvala.in.
                    </li>
                    <li>
                      <b>Call Support: </b>
                      Speak with our customer service team at *** **** *128.
                    </li>
                  </ol>
                  <p className="font-para">
                    After your request is successfully submitted, we’ll send a
                    confirmation email, and the refund process will be
                    initiated.
                  </p>
                </div>
              </div>
              <div className="col-md-12 col-lg-12">
                <div className="request_refund">
                  <h6>Eligibility for Refund</h6>
                  <p className="py-2">
                    Refunds will be granted if you meet these conditions:
                  </p>
                </div>
                <div className="refund_policy_points">
                  <ol className="refund_num">
                    <li>The purchase was made within the past 30 days.</li>
                    <li>
                      A job post has been live for at least 3 consecutive days
                      following your purchase.
                    </li>
                    <li>
                      Your profile has been verified and adheres to the Kaamvala
                      platform guidelines. Please review our policies for more
                      details.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 pb-3 text-refund-policy">
            <h6>Refund Processing Time</h6>
            <p className="jjjjj">
              Once a refund is approved, it will be processed within 7-10
              business days.
            </p>
          </div>
          <div className="col-md-12 col-lg-12">
            <div className="request_refund">
              <h6>Non-Refundable Scenarios</h6>
            </div>
            <div className="refund_policy_points">
              <ol className="refund_num">
                <li>Refund requests are made after 30 days of purchase.</li>
                <li>
                  If the services have been fully utilized (e.g., all job posts
                  and features have been used).
                </li>
                <li>
                  Accounts found violating Kaamvala’s terms and conditions, such
                  as fraudulent or misleading information.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container px-4">
          <table
            className="table-border"
            style={{
              width: "100%",
            }}
          >
            <colgroup>
              <col span="2" />
            </colgroup>
            <tbody>
              <tr>
                <th></th>
                <th className="text-center">Corporate</th>
              </tr>
              <tr>
                <td className="table-data">
                  If you have purchased the plan directly from our website or
                  mobile app
                </td>
                <td className="table-data">
                  {" "}
                  100% of the plan purchase amount If you are eligible
                </td>
              </tr>

              <tr>
                <td className="table-data">
                  In case you have purchased the plan through our sales team
                </td>
                <td className="table-data">
                  The refund will be calculated based on the number of days
                  remaining in your plan validity and will be processed provided
                  the number of responses received is half of the committed
                  response for the plan purchased
                </td>
              </tr>
              <tr>
                <td></td>
                <td className="table-data">
                  For example: if the plan is ₹5000, plan validity is 28 days,
                  the start date is 1st Oct and end date is 28th Oct and refund
                  is raised on 15th, then refund amount will be given for
                  remaining 13 days that will be (5000/28) * 13 = ₹2321
                </td>
              </tr>
              <tr>
                <td className=""></td>
                <td className="table-data">
                  Additionally, If you have received calls from irrelevant
                  candidates, or have issues with candidate quality in the
                  database, our team will verify the cases and the amount will
                  also be refunded (₹50 per call, ₹5 per Database unlock)
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section>
        <div className="container mb-5">
          <div className="col-md-12">
            <h6 className="frequent_asked">Frequently Asked Question</h6>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="all_questions">
                  <p className="p1">Can I request multiple refunds?</p>
                  <p className="p2">
                    No, each plan purchase allows only one refund request.
                  </p>
                </div>
                <div className="all_questions">
                  <p className="p1">
                    How long will it take for my refund to reflect?
                  </p>
                  <p className="p2">
                    Refunds typically take 4-5 business days to process after
                    approval.
                  </p>
                </div>
                <div className="all_questions">
                  <p className="p1">
                    What situations are not covered by Kaamvala for refunds or
                    replacements?
                  </p>
                  <p className="p2">
                    Kaamvala does not cover cases like employee resignation,
                    misconduct, or legal issues.
                  </p>
                </div>
                <div className="all_questions">
                  <p className="p1">
                    What actions can get a company blacklisted on Kaamvala?
                  </p>
                  <p className="p2">
                    Types of Employers Kaamvala Does Not Support:-
                  </p>
                </div>
                <div className="other_question">
                  <p className="third-party">1.Third-Party Agencies</p>
                  <div>
                    <ol>
                      <li>
                        Companies hiring employees on behalf of another company.
                      </li>
                      <li>
                        Employers who charge job seekers for job placement
                        services.
                      </li>
                    </ol>
                  </div>
                  <div className="other_questions">
                    <p>2.Inappropriate Job Posting</p>
                    <div>
                      <ol>
                        <li>
                          Job listings with offensive or inappropriate content.
                        </li>
                        <li>
                          Jobs demanding unethical personal favors or services.
                        </li>
                        <li>
                          Employers involved in illegal activities like human
                          trafficking.
                        </li>
                        <li>
                          Jobs with religious, sexual, or political motivations.
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="other_questions">
                    <p>3.pyramid Schemes & MLM Jobs</p>
                    <div>
                      <ol>
                        <li>Pyramid Schemes & MLM Jobs</li>
                        <li>
                          Job postings designed to promote products through
                          network marketing.
                        </li>
                        <li>
                          Employers involved in pyramid schemes that target job
                          seekers for recruitment.
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="other_questions">
                    <p>4.Misleading Jobs Ads</p>
                    <div>
                      <ol>
                        <li>
                          Employers posting fake or exaggerated job details to
                          attract candidates.
                        </li>
                        <li>
                          Job postings that provide false information or mislead
                          applicants.
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="all_questions">
                    <p className="p1">
                      Can I request a refund if I partially used the service?
                    </p>
                    <p className="p2">
                      Partial refunds are reviewed case by case, based on usage
                      and remaining services.
                    </p>
                  </div>
                  <div className="all_questions">
                    <p className="p1">
                      How will I know if my refund request is approved?
                    </p>
                    <p className="p2">
                      You’ll receive a confirmation email once your refund
                      request is approved.
                    </p>
                  </div>
                  <div className="all_questions">
                    <p className="p1">
                      Are any additional fees applied when processing a refund?
                    </p>
                    <p className="p2">
                      No, refunds are processed without any additional fees, but
                      third-party transaction costs may not be refunded.
                    </p>
                  </div>
                  <div className="all_questions">
                    <p className="p1">
                      How can I check the status of my refund?
                    </p>
                    <p className="p2">
                      You can track the status of your refund through your
                      Kaamvala account dashboard.
                    </p>
                  </div>
                  <div className="all_questions">
                    <p className="p1">
                      Can I still use my account after a refund has been
                      processed?
                    </p>
                    <p className="p2">
                      Yes, once your refund is approved and processed, your
                      account will remain active, but the refunded services or
                      plans will no longer be available for use.
                    </p>
                  </div>
                  <div className="all_questions">
                    <p className="p1">
                      How can I prevent being blacklisted on Kaamvala?
                    </p>
                    <p className="p2">
                      To avoid blacklisting, ensure that you follow our terms of
                      service, post legitimate and ethical job openings, and
                      comply with all applicable laws and guidelines.
                      Transparency in job listings and fair hiring practices are
                      essential..
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </>
);
export default RefundPolicy;
